

export const tipoGineco = (dataSemiologia) => {
  
  //validar si es prenatal o general

  const { 
    anticonceptivos, dolorMenstruacion, edadInicioSexual, 
    enfermedadesSexuales, fechaPartoAnterior, fechaUltimoParto, fechaUltimoPap,
    nAbortos, nCesareas, nGestas, nParejasSexuales, nPartosNaturales, observaciones,
    periodoIntergenesico, tipoPaciente, ultimaMenstruacion

  } = dataSemiologia?.general;

  let textoMenstruacion = '';
  let textoDolorMenstruacion = '';
  let textoGestas = '';
  let textoPartos = '';
  let textoAnticonceptivos = '';
  let textoEnfSexuales = '';
  let textoObservaciones = '';
  let textoParejasSexuales = '';
  let textoEdadSexual = '';
  let textoUltimoPap = '';

  if(ultimaMenstruacion)
    textoMenstruacion = ` Ultima Menstruacion: ${ultimaMenstruacion}`

  if(dolorMenstruacion){
    textoDolorMenstruacion = dolorMenstruacion > '7' 
      ? ' con dolor muy fuerte' 
      : dolorMenstruacion > '5'
        ? ' con dolor fuerte'
        : dolorMenstruacion > '3'
          ? ' con dolor moderado'
          : dolorMenstruacion > '1'
            ? ' con dolor leve'
            : ' sin dolor';
  }

  if( nGestas > 0 ){
    const textoCesareas = (nCesareas > 0) ? ` Cesareas: ${nCesareas}` : '';
    const textoAbortos = (nAbortos > 0) ? ` Abortos: ${nAbortos}` : '';
    const textoPartosNaturales = (nPartosNaturales > 0) ? ` Partos Naturales: ${nPartosNaturales}` : '';
    textoGestas = ` Gestas: ${nGestas}${textoPartosNaturales}${textoCesareas}${textoAbortos}`;
  }

  let textoPartoAnterior = '';
  let textoUltimoParto = '';
  if( fechaPartoAnterior ) textoPartoAnterior = ` fecha parto anterior ${fechaPartoAnterior}`;
  if( fechaUltimoParto ) textoUltimoParto = ` fecha ultimo parto ${fechaUltimoParto}`;
  textoPartos = `${textoPartoAnterior}${textoUltimoParto}`;

  if( anticonceptivos.length > 0 ) 
    textoAnticonceptivos = ` Anticonceptivos: ${anticonceptivos.map( anticonceptivo => anticonceptivo.text ).join(', ')}`;

  if( enfermedadesSexuales.length > 0 )
    textoEnfSexuales = ` Enfermedades sexuales: ${enfermedadesSexuales.map( enfermedad => enfermedad.text ).join(', ')}`;

  if( nParejasSexuales !== '' )
    textoParejasSexuales = ` Parejas sexuales: ${nParejasSexuales}`;
  
  if( nParejasSexuales !== '' )
    textoEdadSexual = ` Edad inicio relaciones sexuales: ${edadInicioSexual}`;

  if( fechaUltimoPap ) textoUltimoPap = ` Fecha de Papanicolau: ${fechaUltimoPap}`

  textoObservaciones = ` ${observaciones}`

  return `${textoMenstruacion}${textoDolorMenstruacion}${textoGestas}${textoPartos}${textoAnticonceptivos}${textoEnfSexuales}${textoParejasSexuales}${textoEdadSexual}${textoUltimoPap}${textoObservaciones}`;

}